import ScreenOption from "./screen-option";
import CreateButton from "./create-button";
import { initAcServices } from "AC/helpers/admin-columns";
import { getTableConfig } from "AC/table/utils/global";
import axios from "axios";
import { mapDataToFormData } from "AC/helpers/global";
var AcServices = initAcServices();
var AddNewInline = /** @class */ (function () {
    function AddNewInline(actions) {
        this.loading = false;
        this.createButton = new CreateButton(actions);
        this.screenOption = null;
        var screenOptionsElement = document.getElementById('acp_new_inline_show_button-1');
        if (screenOptionsElement) {
            this.screenOption = new ScreenOption(screenOptionsElement);
        }
        this.initEvents();
    }
    AddNewInline.prototype.initEvents = function () {
        var _this = this;
        if (this.screenOption && !this.screenOption.isEnabled()) {
            this.createButton.disable();
        }
        if (this.screenOption) {
            this.screenOption.events.addListener('changeState', function (state) {
                state ? _this.createButton.enable() : _this.createButton.disable();
            });
        }
        this.createButton.events.addListener('click', function () {
            _this.addNew();
        });
    };
    AddNewInline.prototype.addNew = function () {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.createButton.toggleLoading(true);
        var tableConfig = getTableConfig();
        axios.post(window.location.href, mapDataToFormData({
            ac_action: 'acp_add_new_inline',
            _ajax_nonce: tableConfig.ajax_nonce,
            list_screen: tableConfig.list_screen,
            layout: tableConfig.layout
        }))
            .then(function (response) {
            var _a;
            var data = response.data;
            if (data && data.success && ((_a = data.data) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('row'))) {
                var temp = document.createElement('tbody');
                temp.innerHTML = data.data.row;
                var row_1 = temp.firstElementChild;
                document.querySelector('table.wp-list-table tbody').prepend(row_1);
                row_1.style.opacity = '0';
                row_1.style.transition = "opacity 600ms ease";
                requestAnimationFrame(function () {
                    row_1.style.opacity = '1';
                });
                AcServices.getService('Table').updateRow(row_1);
                if (AcServices.hasService('Editing') &&
                    AcServices.getService('Editing').hasService('InlineEdit')) {
                    AcServices.getService('Editing')
                        .getService('InlineEdit')
                        .initRow(data.data.id);
                }
            }
        })
            .catch(function (error) {
            console.error('Error adding new inline row:', error);
        })
            .finally(function () {
            _this.loading = false;
            _this.createButton.toggleLoading(false);
        });
    };
    return AddNewInline;
}());
export default AddNewInline;
